import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import { SessionHistory } from '@/services/sessionHistory';
import { SessionDetail } from './SessionDetail';

export const SessionHistoryScreen = ({ onBack }) => {
  const [selectedSession, setSelectedSession] = useState(null);
  const history = SessionHistory.getHistory();
  
  if (selectedSession) {
    return (
      <SessionDetail
        session={selectedSession}
        onBack={() => setSelectedSession(null)}
      />
    );
  }
  
  return (
    <div className="min-h-screen p-4 md:p-8" data-testid="session-history-screen">
      <div className="max-w-4xl mx-auto space-y-8">
        {/* Header */}
        <div className="flex items-center gap-4">
          <button
            onClick={onBack}
            className="text-slate-400 hover:text-slate-200 transition-colors"
            data-testid="history-back-btn"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
          <div className="flex-1">
            <h1 className="text-3xl font-heading text-slate-100">
              Oturum Geçmişi
            </h1>
            <p className="text-slate-400 text-sm mt-1">
              Geçmiş test sonuçların
            </p>
          </div>
        </div>
        
        {/* Session list */}
        {history.length === 0 ? (
          <div className="glass-panel p-12 text-center">
            <p className="text-slate-400">Henüz kayıtlı oturum yok.</p>
            <p className="text-slate-500 text-sm mt-2">Geçmişini görmek için bir oturum tamamla.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {history.map((session) => (
              <motion.button
                key={session.sessionId}
                onClick={() => setSelectedSession(session)}
                className="w-full glass-panel p-6 text-left hover:border-violet-500/30 transition-all"
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
                data-testid={`history-item-${session.sessionId}`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1 space-y-2">
                    <div className="flex items-center gap-4">
                      <h3 className="text-lg font-heading text-slate-100">
                        {session.sessionLabel}
                      </h3>
                      <div className="flex items-center gap-2 text-xs">
                        <span className="px-2 py-1 rounded-full bg-violet-500/20 text-violet-400">
                          Level {session.level}
                        </span>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-6 text-sm text-slate-400">
                      <span>{new Date(session.dateTime).toLocaleDateString('tr-TR')}</span>
                      <span className="text-green-400">{session.accuracy}% doğruluk</span>
                      <span>{session.hits}/{session.total} isabet</span>
                    </div>
                  </div>
                  
                  <ChevronRight className="w-5 h-5 text-slate-600" />
                </div>
              </motion.button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
